// this utility is use to minify the url parameter
define(function(require) {

    let terms = [
        { short:'"exflt"', long:'"extendedFilter"' },
        { short:'"op"', long:'"operator"' },
        { short:'"prop"', long:'"property"' },
        { short:'"Prop"', long:'"Property"' },
        { short:'"val"', long:'"value"' },
        { short:'"typs"', long:'"types"' },
        { short:'">"', long:'"GreaterThan"' },
        { short:'">="', long:'"GreaterThanOrEqual"' },
        { short:'"<"', long:'"LessThan"' },
        { short:'"<="', long:'"LessThanOrEqual"' },
        { short:'"=="', long:'"Equal"' },
        { short:'"!="', long:'"NotEqual"' },
        { short:'"="', long:'"Like"' },
        { short:'"flNme"', long:'"Contacts.contact.identity.fullName"' },
        { short:'"fNme"', long:'"Contacts.contact.identity.firstName"' },
        { short:'"lNme"', long:'"Contacts.contact.identity.lastName"' },
        { short:'"stNum"', long:'"sites.Address.StreetNumber"' },
        { short:'"suff"', long:'"sites.Address.Suffix"' },
        { short:'"area"', long:'"sites.Address.Area"' },
        { short:'"cty"', long:'"sites.Address.City"' },
        { short:'"parcId"', long:'"Sites.parcel.parcelId"' },
        { short:'"istNum"', long:'"instrument.Sites.Address.StreetNumber"' },
        { short:'"istNme"', long:'"instrument.Sites.Address.StreetName"' },
        { short:'"isuff"', long:'"instrument.Sites.Address.Suffix"' },
        { short:'"iarea"', long:'"instrument.Sites.Address.Area"' },
        { short:'"icity"', long:'"nstrument.Sites.Address.City"' },
        { short:'"iparcId"', long:'"instrument.sites.parcel.parcelId"' },
        { short:'"bname"', long:'"businessName"' },
        { short:'"cntctId"', long:'"Contacts.Contact.Id"' },
        { short:'"t_Code"', long:'"instrumentSubTypeCode"' },
        { short:'"insType"', long:'"instrumentType"' },
        { short:'"addDT"', long:'"addedDateTime"' },
        { short:'"appDT"', long:'"approvedDateTime"' },
        { short:'"licDT"', long:'"licenseDateTime"' },
        { short:'"reqDT"', long:'"requestDateTime"' },
        { short:'"fnlDT"', long:'"finalDateTime"' },
        { short:'"clDT"', long:'"callDateTime"' },
        { short:'"rsDT"', long:'"resultDateTime"' },
        { short:'"scDT"', long:'"scheduledDateTime"' },
        { short:'"coDT"', long:'"cooDateTime"' },
        { short:'"lreDT"', long:'"lastRenewalDateTime"' },
        { short:'"inaDT"', long:'"inactiveDateTime"' },
        { short:'"isDT"', long:'"issuedDateTime"' },
        { short:'"prcDT"', long:'"processedDateTime"' },
        { short:'"tcoDT"', long:'"tempCooDateTime"' },
        { short:'"rtnDT"', long:'"resolutionDateTime"' },
        { short:'"crmlc"', long:'"currentMilestoneCode"' },
        { short:'"inName"', long:'"instrumentName"' },
        { short:'"clcv"', long:'"calculatedValuation"' },
        { short:'"pPrjId"', long:'"parentProjectId"' },
        { short:'"csrc"', long:'"caseSource"' },
        { short:'"dval"', long:'"declaredValuation"' },
        { short:'"dbsna"', long:'"doingBusinessAs"' },
        { short:'"eDT"', long:'"endDate"' },
        { short:'"exDT"', long:'"expireDate"' },
        { short:'"gpd"', long:'"gracePeriod"' },
        { short:'"inpc"', long:'"inspectionCompleted"' },
        { short:'"inpas"', long:'"inspectorAssigned"' },
        { short:'"dUnpd"', long:'"DueNowUnpaidAmount"' },
        { short:'"nxrDT"', long:'"nextRenewalDate"' },
        { short:'"numpg"', long:'"numberOfPages"' },
        { short:'"numpl"', long:'"numberOfPlans"' },
        { short:'"octyp"', long:'"occupancyType"' },
        { short:'"phnm"', long:'"phaseNumber"' },
        { short:'"prpnm"', long:'"property.propertyName"' },
        { short:'"rqc"', long:'"requestCompleted"' },
        { short:'"rtn"', long:'"resolution"' },
        { short:'"szdsc"', long:'"sizeDescription"' },
        { short:'"sqft"', long:'"squareFootage"' },
        { short:'"srDT"', long:'"startDate"' },
        { short:'"isbdsc"', long:'"InstrumentSubTypeCodeDescription"' },
        { short:'"sdvdsc"', long:'"SubDivisionDescription"' },
        { short:'"typb"', long:'"typeOfBusiness"' },
        { short:'"uamt"', long:'"UnpaidAmount"' },
        { short:'"pckr1"', long:'"statusDateCriteria.picker1.type"' },
        { short:'"pckr2"', long:'"statusDateCriteria.picker2.type"' },
        { short:'"pckr3"', long:'"statusDateCriteria.picker3.type"' },
        { short:'"clseIns"', long:'"IsClosedInstrument"' },
        { short:'"dtcpckr"', long:'"dateCriteriaPicker"' },
        { short:'"pstobj"', long:'"passThroughObject"' },
        { short:'"incnt"', long:'"includecount"' },
        { short:'"oby"', long:'"orderBy"' },
        { short:'"asgtprvId"', long:'"AssignedToProvider.Id"' },
        { short:'"stdec"', long:'"statusDescription"' },
        { short:'"pdec"', long:'"portalDescription"' },
        { short:'"drct"', long:'"direction"' },
        { short:'"stat"', long:'"status"' },
        { short:'"insnum"', long:'"instrumentNumber"' },
        { short:'"pins"', long:'"PortalInstrument"' },
        { short:'"tmp"', long:'"timePreference"' },
        { short:'"psce"', long:'"PortalScenario"' },
        { short:'"svcrit"', long:'"isViewCriteria"' },
        { short:'"crtval"', long:'"criteriaValue"' },
        { short:'"AssntInstNumber"', long:'"Assignment.Instrument.InstrumentNumber"' },
        { short:'lke', long:'%' },
        { short:'"instmlstn"', long:'"instrumentMilestoneCode"'},
        { short:'"rl"', long:'"role"'},
        { short:'"tskstat"', long:'"taskStatus"'},
        { short:'"tskopnclsd"', long:'"taskOpenClosed"'},
        { short:'"hsopvltn"', long:'"hasopenviolation"'},
        { short:'"assopncls"', long:'"assignmentOpenClosed"'},
        { short:'"assstat"', long:'"assignmentStatus"'}
        ]
        

    return {
        minifyFilterString: function(filterString) {
            let retFilter = '';
            if(!_.isEmpty(filterString)){
                retFilter = filterString;
                _.each(terms, (term)=>{
                    retFilter = retFilter.replace(new RegExp(term.long, 'gi'), term.short);
                });
            }

            return retFilter;
        }, 
        // charToRemove should be array
        unMinifyFilterString: function(filterString, charToRemove) {
            let retFilter = '';
            if(!_.isEmpty(filterString)){
                retFilter = decodeURI(filterString);
                _.each(terms, (term)=>{
                    retFilter = retFilter.replace(new RegExp(term.short, 'gi'), term.long);
                });
    
                // use to remove the character on unminify string
                // ie, we need to set the value in the field so we need to remove the % for like parameter
                if(charToRemove){
                    _.each(charToRemove, (char)=>{
                        retFilter = retFilter.replace(new RegExp(char, 'g'), '');
                    });
                }   
            }

            return retFilter;
        }
    };
});
